import { IChannel } from '../models/ichannel';
import { EcgMeasures } from '../models/ecgmeasures';
import { ICaliperViewModel, ILayout, IPointerViewModel, ITraceViewModel, IWindowViewModel } from '../models/interfaces';
import { WindowViewModel } from './window-viewmodel';
import { PointerViewModel } from './pointer-viewmodel';

export class CaliperViewModel implements ICaliperViewModel {
    // data members

    pointer1: IPointerViewModel;
    pointer2: IPointerViewModel;
    window: IWindowViewModel;
    title: string = '';
    private _layout: ILayout;
    private _x: number = 0;
    private _width: number = 0;

    constructor(trace: ITraceViewModel, layout: ILayout, channel: IChannel) {
        this._layout = layout;

        this.pointer1 = new PointerViewModel(layout, trace, channel, 10, 1);
        this.pointer2 = new PointerViewModel(layout, trace, channel, 30, 2);

        this.window = new WindowViewModel(this);
    }

    // constructor

    private _highlight: boolean = false;

    // properties

    get highlight() {
        return this._highlight;
    }

    set highlight(highlight: boolean) {
        this._highlight = highlight;
        this.window.opacity = highlight ? this.opacity : 0;
    }

    private _opacity = 1;

    get opacity() {
        return this._opacity;
    }

    set opacity(opacity: number) {
        this._opacity = opacity;

        this.pointer1.opacity = opacity;
        this.pointer2.opacity = opacity;
        this.window.opacity = opacity;
    }

    // public functions

    private _measures: EcgMeasures | null = null;

    get measures(): EcgMeasures | null {
        return this._measures;
    }

    update() {
        this.pointer1.update();
        this.pointer2.update();
    }

    updateMeasures(measures: EcgMeasures) {
        this._measures = measures;
    }

    updatePosition(windowPositionX: number, windowWidth: number, pointerPosition1: number, pointerPosition2: number) {
        this.setPositionX(windowPositionX, windowWidth);
        this.setPointerPosition(1, pointerPosition1);
        this.setPointerPosition(2, pointerPosition2);
    }

    setPositionX(x: number, window?: number) {
        if (window == null) window = this.window.width;
        const leadWidth = this._layout?.context?.leadWidth ?? 0;
        this.setPointerPosition(1, x - window / 2 >= 0 ? x - window / 2 : 0);
        this.setPointerPosition(2, x + window / 2 <= leadWidth ? x + window / 2 : leadWidth);

        this.window.x = Math.min(this.pointer1.positionX, this.pointer2.positionX);
        this.window.width = Math.abs(this.pointer2.positionX - this.pointer1.positionX);

        this._x = x;
        this._width = this.window.width;
    }

    getPositionX() {
        return this._x;
    }

    getWindow() {
        return this._width;
    }

    setPointerPosition(index: number, x: number) {
        if (index == 1) this.pointer1.positionX = x;
        else this.pointer2.positionX = x;

        this.window.x = Math.min(this.pointer1.positionX, this.pointer2.positionX);
        this.window.width = Math.abs(this.pointer2.positionX - this.pointer1.positionX);
    }
}
